import { identifyUser, setWorkspaceContext, resetAnalytics, trackCanvasEvent } from '../../lib/analytics';
import { authActionTypes } from '../auth/auth.types';
import { workspaceActionTypes } from '../workspace/workspace.types';
import { diagramActionTypes } from '../diagram/diagram.types';

// Maps domain actions to PostHog identity/enrichment. Always lets the action
// through first; analytics is best-effort and never breaks the app.
const analyticsMiddleware = () => (next) => (action) => {
    const result = next(action);
    try {
        switch (action?.type) {
            case authActionTypes.SIGN_IN_SUCCESS:
                identifyUser(action.payload?.user);
                break;
            case workspaceActionTypes.WORKSPACE_INIT_SUCCESS:
            case workspaceActionTypes.WORKSPACE_SWITCH_SUCCESS:
                setWorkspaceContext(action.payload?.currentWorkspace);
                break;
            case authActionTypes.SIGN_OUT_SUCCESS:
                resetAnalytics();
                break;
            case diagramActionTypes.TOGGLE_BTN_MINIMAP:
                trackCanvasEvent('app_canvas_minimap_toggle');
                break;
            case diagramActionTypes.TOGGLE_BTN_EXPORT_IMAGE:
                trackCanvasEvent('app_canvas_export_image');
                break;
            default:
                break;
        }
    } catch (_) {
        // Best-effort — never block the action or throw into dispatch.
    }
    return result;
};

export default analyticsMiddleware;
